import { render, staticRenderFns } from "./ancientBooks.vue?vue&type=template&id=fd17d10e&scoped=true"
import script from "./ancientBooks.vue?vue&type=script&lang=js"
export * from "./ancientBooks.vue?vue&type=script&lang=js"
import style0 from "./ancientBooks.vue?vue&type=style&index=0&id=fd17d10e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd17d10e",
  null
  
)

export default component.exports